// extracted by mini-css-extract-plugin
export default {"page":"theme_page__nmdAY","title":"theme_title__vZq8j","chart":"theme_chart__aryqW"};